
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultation",
      function () {
        return require("private-next-pages/consultation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultation"])
      });
    }
  